// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WvAN","right":"styles_right__2Fa-Y"};